import { useTranslation } from 'react-i18next';
import GridComponent from '../../components/grid/grid-comp';
import { useState, useEffect } from 'react';
import SwiperSlider from '../../components/SwiperSlider';
import * as httpService from '../../services/HTTPService';
import SpinLoader from "../../components/spin-loader";
import { hideOverlay } from "../../utils/utils";
import { useNavigate } from 'react-router-dom';
import { PlaceholderHTML } from '../../components/grid/grid-comp';
import { ToastContainer, toast } from 'react-toastify';

const MoodboardComponent = () => {
    const navigate = useNavigate();
    const user: any = localStorage.getItem('auth-user');
    const authUser = JSON.parse(user);
    const { email } = authUser;
    const { t, i18n } = useTranslation();
    const moodBoardLbl = i18n.exists("pages.moodboard") ? t('pages.moodboard') : "Moodboard";
    const createdSuccessfulLbl = i18n.exists("pages.createdSuccessful") ? t('pages.createdSuccessful',  {value: moodBoardLbl}) : "Бордът е създаден успешно."; 
    const sectionNameLbl = i18n.exists("pages.sectionNameLbl") ? t('pages.sectionNameLbl') : "Име на борда";
    const createLbl = i18n.exists("pages.create") ? t('pages.create') : "Създай";
    const addFromLbl = i18n.exists("pages.addFromLbl") ? t('pages.addFromLbl') : "Можете да добавите от нашия";
    const catalogLbl = i18n.exists("pages.catalogLbl") ? t('pages.catalogLbl') : "каталог";
    const productsLbl = i18n.exists("pages.products") ? t('pages.products') : "продукта";
    let [mbData, setMbData] = useState([]);
    const [showCreate, setShowCreate] = useState(false);
    let [isSpinning, setIsSpinning] = useState(true);
    let [products, setProducts] = useState([]);
    const urlParamMoodboardId = window.location.href.split('/').pop();
    const [moodboardName, setMoodboardName] = useState('');

    const CreatePopup = () => {
        const [createValue, setCreateValue] = useState('');
        

        const onCreateValueChange = (e: any) => {
            setCreateValue(e.target.value);
        }

        const createMoodboard = () => {
            setIsSpinning(true);
            if(createValue.length > 0) {
                //console.log(createValue)
                const body = {
                    name: createValue,
                    userId: email
                }
                httpService.createMoodboard(body).then((res) => {
                    setIsSpinning(false);
                    hideOverlay();
                    //console.log(res);
                    getAllMoodboards();
                    toast.success(createdSuccessfulLbl);
                })
                .catch(err => {
                    setIsSpinning(false);
                    hideOverlay();
                    console.log(err);
                    toast.error(t('forms.commonErrMsg'));
                });

                setShowCreate(false);
            }
        }

        return (
            <div className='create-popup'>
                <h3 className='inter-light'>{sectionNameLbl}</h3>
                <div className='create-popup-in'>
                    <input onChange={onCreateValueChange} type="text" />
                    <div className='align-right'>
                        <button className='btn btn-primary inter-light' onClick={createMoodboard} disabled={createValue === "" ? true : false} >{createLbl}</button>
                    </div>
                </div>
            </div>
        )
    }

    const onCreateMoodboardClick = () => {
        setShowCreate(!showCreate);
    }

    const getAllMoodboards = () => {
        let data: any = [];

        
        httpService.getAllMoodboards(email).then((res: any) => {
            if(res) {
                data = res.data;
                setMbData(res.data);
                // set the first moodboard to be current
                if(res.data.length > 0 && res.data[0].products.length > 0) {
                    //setProducts(res.data[0].products)
                }
            }
        })
        setMbData(data);
    }

    const getMoodboardProducts = () => {
        let moodboardProducts: any = [];
        if(urlParamMoodboardId) {
            httpService.getMoodboardById(urlParamMoodboardId).then((res) => {
                setIsSpinning(false);
                hideOverlay();
                if(res) {
                    products = res.data.products;
                    moodboardProducts = res.data.products;
                    setMoodboardName(res.data.name);
                    setProducts(res.data.products);
                }
            })
            .catch((err) => {
                console.log(err);
                setIsSpinning(false);
                hideOverlay();
            })
        }
        else {
            setProducts(moodboardProducts);
        }
    }

    const getDataSource = (data: any) => {
        setProducts(data);
        setIsSpinning(false);
        hideOverlay();
    }

    const loadCurrentMoodboard = (moodboardData: any) => {
        navigate(`/moodboard/${moodboardData.id}`);
        setProducts(moodboardData.products);
    }

    useEffect(() => {
        getAllMoodboards();
        getMoodboardProducts();

    }, [])

    return (
        <div className="content-wrapper">
            <ToastContainer position="top-center"
 />
            <div className='create-section'>
                <div className={showCreate ? `flex-right show-create` : 'flex-right'}>
                    <span onClick={onCreateMoodboardClick} className='create-section-btn'>{i18n.exists("pages.createSection") ? t('pages.createSection') : "Създай Борд"}</span>
                </div>
                <div className='search-button'>
                    <img src='/img/search_light-2x.png' alt='search' />
                </div>
                {showCreate ? (
                    <CreatePopup />
                ) : null}
            </div>
            {mbData.length > 0 ? (
                <div className='swiper-mood-list'>
                    <SwiperSlider getAllMoodboards={getAllMoodboards} sliderSource={mbData} loadCurrentMoodboard={loadCurrentMoodboard} />
                </div>
            ) : null}
            <div className="catalog-page-inner">
                {/* <h2>{moodboardName}</h2> */}
                {urlParamMoodboardId && products.length > 0 ? (
                    <GridComponent reloadItems={getMoodboardProducts} dataSource={getDataSource} products={products} />
                ) : null}
            </div>
            {!isSpinning && products.length === 0 && urlParamMoodboardId !== "moodboard" ? (
                <div className='empty-board'>
                    <p>0 {productsLbl}.</p>
                    {addFromLbl}
                    <span className='brand-anchor' onClick={() =>navigate('/')}> {catalogLbl}</span>.
                </div>
            ) : null}
            {isSpinning && products.length === 0 ? (
                <div style={{"maxWidth" : "1143px", "margin": "auto"}}>
                    <PlaceholderHTML />
                </div>
            ) : null}
            {isSpinning ? (
                <SpinLoader />
            ) : null}
    </div>
    )
}

export default MoodboardComponent;